const ITEMS = [
  "$TATE",
  "MAKE MEMES GREAT AGAIN",
  "ATTENTION IS EVERYTHING",
  "ONE TICKER. ONE MOVEMENT.",
  "LOUDER MEMES",
  "UNLIMITED MEME POTENTIAL",
];

function Row({ items, outline, trackClass }) {
  const content = [...items, ...items];
  return (
    <div className="group flex overflow-hidden">
      <div className={`flex shrink-0 items-center gap-10 whitespace-nowrap pr-10 transition-[animation-duration] group-hover:[animation-play-state:paused] ${trackClass}`}>
        {content.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-display text-2xl font-black uppercase tracking-tight sm:text-3xl ${
                outline ? "text-stroke-gold" : "text-[#07080A]"
              }`}
            >
              {t}
            </span>
            <svg viewBox="0 0 24 24" className={`h-4 w-4 ${outline ? "fill-[#E5A93C]" : "fill-[#07080A]"}`} aria-hidden="true">
              <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}

export default function EditorialTicker() {
  return (
    <section className="relative z-10 -my-4 select-none overflow-hidden" data-testid="editorial-ticker" aria-hidden="true">
      <div className="-rotate-1 scale-[1.02] border-y border-[#B8860B] bg-[#E5A93C] py-3.5">
        <Row items={ITEMS} trackClass="marquee-track-left" />
      </div>
      <div className="rotate-[0.75deg] border-y border-[rgba(229,169,60,0.25)] bg-[#0F1E36] py-3.5">
        <Row items={[...ITEMS].reverse()} outline trackClass="marquee-track-right" />
      </div>
    </section>
  );
}
